import { CustomCard } from "../CustomCard/CustomCard";
import React, { useContext, useState } from "react";
import {
  daysJsFormat,
  formatCurrency,
  isInstitutionGrouped,
  renderItemBillTraductionRetro,
  renderStatusLabels,
  renderTravel,
  roles,
  subRoles,
} from "../../../utils/constants";
import { RenderCostsTable } from "./RenderCostsTable";
import { getTvaRatio } from "../../../utils/helpersFunction";
import { UserContext } from "../../../engine/context/User.context";
import { t } from "i18next";
import { useTranslation } from "react-i18next";
import { FiHelpCircle } from "react-icons/fi";
import { colorPrimary } from "../../../root";
import { Button, Modal, Space, Tooltip } from "antd";
import { onlyRoleMapping } from "../../../engine/AuthRoute";
import { MdAdminPanelSettings } from "react-icons/md";
import dayjs from "../../../utils/dayjs";

export const RenderCosts = ({
  cost,
  title,
  loading,
  prestationVue,
  prestation,
}) => {
  const translation = useTranslation();

  const [open, setOpen] = useState(false);

  const showModal = () => {
    setOpen(true);
  };
  const handleOk = () => {
    setOpen(false);
  };

  const handleCancel = () => {
    setOpen(false);
  };
  if (cost === null) {
    return null;
  }

  const lnKey = translation.i18n.language;

  const { configuration } = useContext(UserContext);

  const renderDetailCostAdmin = (detail, detailCost) => {
    return (
      <div>
        {detail?.tranches.map((tranche, index) => (
          <div key={index} style={{ marginBottom: "1rem" }}>
            <h4>Tranche {index + 1}</h4>
            <ul>
              {Object.entries(tranche).map(([key, value]) => {
                // Vérifier si la clé est "start" ou "end" et formater la valeur si c'est une date valide
                const formattedValue =
                  (key === "start" || key === "end") &&
                  dayjs(value, dayjs.ISO_8601, true).isValid()
                    ? dayjs(value).format(daysJsFormat.full)
                    : value?.toString();
                return (
                  <li key={key}>
                    {key}: <strong>{formattedValue}</strong>
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </div>
    );
  };

  const renderLinesCost = (costs, costParams, params) => {
    const renderTravel = description => {
      let chain;

      if (typeof description === "string") {
        chain = description;
      } else {
        chain = description[lnKey];
      }

      return chain.split("\n").map((line, index, array) => (
        <React.Fragment key={index}>
          {line}
          {index === array.length - 1 ? null : <br />}
        </React.Fragment>
      ));
    };

    return (
      <>
        {costs?.map(entry => {
          return (
            <div className={"row-price"}>
              <p>{renderItemBillTraductionRetro(entry.title, lnKey)}</p>

              <div className={"row-price-sub"}>
                <span className={"row-price-left"}>
                  {entry.type === "travel"
                    ? renderTravel(entry, costParams, params?.billing, lnKey)
                    : renderTravel(entry.description)}
                </span>

                <span className={"row-price-right"}>
                  {formatCurrency(entry.amount)}
                </span>
              </div>
            </div>
          );
        })}
        {costs === undefined
          ? `${t("RenderCosts.prestation")}: ${renderStatusLabels(
              prestation.status,
              prestation.subStatus,
            )}`
          : ""}

        <div className={"row-price-total"}>
          <div className={"row-price-sub"}>
            <span className={"row-price-left-total"}>
              {t("RenderCosts.totalNet")}
            </span>
            <span className={"row-price-right-total"}>
              {formatCurrency(costParams?.total)}
            </span>
          </div>
        </div>

        {params.showNote === true &&
          cost.noteCreditAmount !== undefined &&
          cost.noteCreditAmount !== null &&
          cost.noteCreditAmount !== 0 && (
            <div className={"row-price-total"}>
              <div className={"row-price-sub"}>
                <span className={"row-price-left"}>
                  {t("billEdit.billingNote")} : {cost.noteCredit}
                </span>
                <span className={"row-price-right"}>
                  {formatCurrency(cost.noteCreditAmount)}
                </span>
              </div>
            </div>
          )}

        {costParams?.tvaAmount !== undefined && costParams?.tvaAmount !== 0 && (
          <div>
            <div className={"row-price-sub"}>
              <span className={"row-price-left"}>
                {t("RenderCosts.tvaLabel", {
                  tvaRatio: getTvaRatio(cost?.prestationsRef?.year) * 100,
                })}{" "}
              </span>
              <span className={"row-price-right"}>
                {formatCurrency(costParams?.tvaAmount)}
              </span>
            </div>
          </div>
        )}
        {costParams?.totalHorsTva !== undefined &&
          costParams?.totalHorsTva !== 0 && (
            <div>
              <div className={"row-price-sub"}>
                <span className={"row-price-left-total"}>
                  {t("RenderCosts.totalNoTva")}
                </span>
                <span className={"row-price-right-total"}>
                  {formatCurrency(costParams?.totalHorsTva)}
                </span>
              </div>
            </div>
          )}
        {costParams?.roundCorrection !== 0 &&
        costParams?.roundCorrection !== undefined ? (
          <div>
            <div className={"row-price-sub"}>
              <span className={"row-price-left"}>
                {t("RenderCosts.roundCorrection")}
              </span>
              <span className={"row-price-right"}>
                {formatCurrency(costParams?.roundCorrection)}
              </span>
            </div>
          </div>
        ) : null}
        {costParams?.isCancelInterprete !== undefined &&
          costParams?.isCancelInterprete === true && (
            <div>
              <div className={"row-price-sub"}>
                <span className={"row-price-left"}>
                  {t("RenderCosts.canceledInterpreter")}
                </span>
                <span className={"row-price-right"}></span>
              </div>
            </div>
          )}
        {costParams?.isCanceledClient !== undefined &&
          costParams?.isCanceledClient === true && (
            <div>
              <div className={"row-price-sub"}>
                <span className={"row-price-left"}>
                  {configuration?.bill?.cancelationType === "less24hours" && (
                    <>
                      {costParams.cancelSince >= 4 &&
                      costParams.cancelSince < 24
                        ? t("RenderCosts.canceledBetween24And4")
                        : ""}
                      {costParams.cancelSince < 4
                        ? t("RenderCosts.canceledLessThan4")
                        : ""}
                    </>
                  )}

                  {configuration?.bill?.cancelationType ===
                    "less4openingHours" && (
                    <>{t("RenderCosts.canceledLessThan4Opening")}</>
                  )}
                </span>
                <span className={"row-price-right"}></span>
              </div>
            </div>
          )}

        {prestation?.status === "cancel" &&
        prestation?.cancel?.showCancelNoteBill === true ? (
          <>
            <div className={"row-price-sub"}>
              <span className={"row-price-left"}>
                {t("PrestationCancel.raison")}
                <b>{prestation?.cancel.cancelNote}</b>
              </span>
              <span className={"row-price-right"}></span>
            </div>
          </>
        ) : null}

        {costParams?.totalWithTva !== undefined &&
          costParams?.totalWithTva !== 0 && (
            <div className={"row-price-total"}>
              <div className={"row-price-sub"}>
                <span className={"row-price-left-total"}>
                  {t("RenderCosts.totalWithTva")}
                </span>
                <span className={"row-price-right-total"}>
                  {formatCurrency(costParams?.totalWithTva)}
                </span>
              </div>
            </div>
          )}
      </>
    );
  };

  if (cost?.type === "multiple") {
    let item;
    let presta;

    if (prestationVue) {
      item = cost.costsMultiple.find(p => p.prestationId === prestation._id);
      presta = cost?.prestations?.find(p => p?._id === prestation?._id);
    }

    return (
      <>
        {!prestationVue && (
          <CustomCard
            title={t("RenderCosts.totalCostsTitle")}
            loading={loading}
          >
            {renderLinesCost(cost?.costs, cost?.costParams, {
              description: false,
              billing: cost?.institutionBilling?.defaultAddress,
              showNote: true,
            })}
          </CustomCard>
        )}
        <br />

        {!prestationVue ? (
          <RenderCostsTable cost={cost} />
        ) : (
          <CustomCard
            title={
              <>
                {title}
                {prestationVue === false
                  ? `: ${t("RenderCosts.prestationNumber")} ${
                      prestation.reference
                    }`
                  : ""}

                {onlyRoleMapping([subRoles.superAdmin]) && (
                  <>
                    <Button onClick={showModal} type={"ghost"}>
                      <MdAdminPanelSettings
                        color={colorPrimary}
                        size={20}
                        style={{
                          paddingLeft: 1,
                          paddingRight: 1,
                          marginLeft: 5,
                        }}
                      />
                    </Button>
                    <Modal
                      title="Detail Admin"
                      centered
                      open={open}
                      onOk={() => setOpen(false)}
                      onCancel={() => setOpen(false)}
                      width={600}
                    >
                      <Space>
                        {renderDetailCostAdmin(item?.costParams, item?.cost)}
                      </Space>
                    </Modal>
                  </>
                )}
              </>
            }
            loading={loading}
            style={{ marginBottom: 20 }}
          >
            {renderLinesCost(item?.cost, item?.costParams, {
              billing: presta?.billing,
            })}
          </CustomCard>
        )}
      </>
    );
  } else {
    let billing;

    if (prestationVue) {
      billing = prestation?.billing;
    } else {
      billing = cost?.prestations?.length > 0 && cost?.prestations[0]?.billing;
    }
    return (
      <CustomCard title={title} loading={loading}>
        {renderLinesCost(cost?.costs, cost?.costParams, {
          billing: billing,
        })}
      </CustomCard>
    );
  }
};
